import { render, staticRenderFns } from "./ns.vue?vue&type=template&id=3183d5c4&scoped=true"
import script from "./ns.vue?vue&type=script&lang=js"
export * from "./ns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3183d5c4",
  null
  
)

export default component.exports